var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 23,
    viewBox: "0 0 36 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-6 -13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    transform: "translate(6 13)",
    fill: "rgba(255,255,255,0)",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 8,
    height: 8,
    rx: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    transform: "translate(6 26)",
    fill: "rgba(255,255,255,0)",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 8,
    height: 8,
    rx: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    transform: "translate(19 13)",
    fill: "rgba(255,255,255,0)",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 8,
    height: 8,
    rx: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    transform: "translate(19 26)",
    fill: "rgba(255,255,255,0)",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 8,
    height: 8,
    rx: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    transform: "translate(32 13)",
    fill: "rgba(255,255,255,0)",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 8,
    height: 8,
    rx: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    transform: "translate(32 26)",
    fill: "rgba(255,255,255,0)",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 8,
    height: 8,
    rx: 1,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.2a230c6dca3853daf32248e78589b340.svg";
export { ForwardRef as ReactComponent };